import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import "../../scss/card.css";
import { CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { getLink, handleQuestionUpdate, handleSelectAll, ImageModal, isErrorQuestion, Loader, SolutionModal, validateQuestionData } from '../../components/ModalsCommonFunctions';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import ViewImageAndText from '../../components/ViewImageAndText';

const InstituteUploadCompetitiveExam = () => {
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommon = generateAxiosInstanceCommon();

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteCompetitiveExamNameMasterId: '',
        instituteCompetitiveExamBookMasterId: '',
        instituteSubjectMasterId: '',
        instituteCompetitiveLessonMasterId: '',
        instituteCompetitiveTopicMasterId: '',
        instituteCompetitiveSubTopicMasterId: '',
        importFile: '',
        questionData: []
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicListName, setSubtopicListName] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [bookList, setBookList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const inputFile = useRef(null);

    const [errorQuestions, setErrorQuestions] = useState({})
    const [questionList, setQuestionList] = useState([])
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalData, setModalData] = useState("")
    const [visible, setVisible] = useState(false)
    const [visibleSolution, setVisibleSolution] = useState(false);

    const [showPdfLink, setShowPdfLink] = useState([])
    const [selectedGrade, setSelectedGrade] = useState()
    const [selectedDivision, setSelectedDivision] = useState()
    const [jsonPars, setJasonParse] = useState([])
    const [text, setText] = useState('')
    const [showPdfLinkdataType, setShowPdfLikDateType] = useState()
    const [inputpdf, setInputPdf] = useState({ value: '' })
    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        if (subtopicData.instituteCompetitiveExamBookMasterId !== '') {
            let apiUrl = `/get-institute-competitive-question-bank-import-log?instituteMasterId=${instituteMasterId}&`;

            if (subtopicData.instituteCompetitiveExamNameMasterId) {
                apiUrl += `instituteCompetitiveExamNameMasterId=${subtopicData.instituteCompetitiveExamNameMasterId}&`;
            }

            if (subtopicData.instituteCompetitiveExamBookMasterId) {
                apiUrl += `instituteCompetitiveExamBookMasterId=${subtopicData.instituteCompetitiveExamBookMasterId}&`
            }

            if (subtopicData.instituteCompetitiveLessonMasterId) {
                apiUrl += `instituteCompetitiveLessonMasterId=${subtopicData.instituteCompetitiveLessonMasterId}&`;
            }

            if (subtopicData.instituteCompetitiveTopicMasterId) {
                apiUrl += `instituteCompetitiveTopicMasterId=${subtopicData.instituteCompetitiveTopicMasterId}&`;
            }
            if (subtopicData.instituteCompetitiveSubTopicMasterId) {
                apiUrl += `instituteCompetitiveSubTopicMasterId=${subtopicData.instituteCompetitiveSubTopicMasterId}&`;
            }
            if (subtopicData.instituteSubjectMasterId) {
                apiUrl += `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.data);
                })
                .catch(error => {
                    setSubtopicList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [subtopicData]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-institute-competitive-exam-names?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveExamBookMasterId: '',
                instituteSubjectMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setBookList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleBookChanges = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteSubjectMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChanges = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl = `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${subtopicData.instituteCompetitiveExamBookMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                setLessonList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-competitive-topic-master?instituteMasterId${instituteMasterId}&instituteCompetitiveLessonMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-competitive-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamNameMasterId=${subtopicData.instituteCompetitiveExamNameMasterId}&instituteCompetitiveExamBookMasterId=${subtopicData.instituteCompetitiveExamBookMasterId}&instituteCompetitiveLessonMasterId=${subtopicData.instituteCompetitiveLessonMasterId}&instituteCompetitiveTopicMasterId=${subtopicData.instituteCompetitiveTopicMasterId}&`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubtopicListName(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        let fileExtension = file.name.split(".").pop().toLowerCase();
        const body = new FormData();
        body.append("file", file);
        setInputPdf(e.target)

        if (fileExtension == "xlsx" || fileExtension === "docx") {
            setLoading(true);

            try {
                const link = await getLink(e.target.name, body, setSubtopicData);
                if (!link) throw new Error('Link not generated');

                const endpoint = fileExtension === "docx"
                    ? "convert-question-bank-docx"
                    : "convert-question-bank-xlsx-v2";
                const payload = fileExtension === "docx"
                    ? { "wordFilePath": link }
                    : { "excelFilePath": link };

                const response = await authorizedAxiosCommon.post(endpoint, payload);
                setErrorQuestions(validateQuestionData(response.data.convertedData, true, setQuestionList));
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire(
                { text: "only xlsx & docx file supported" }
            );
        }
    }

    const validateForm = () => {
        const subtopicDataValid = Object.entries(subtopicData).every(([key, value]) => {
            if (key !== 'instituteCompetitiveTopicMasterId' && key !== 'instituteCompetitiveSubTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '') {
                        return false;
                    }
                }
            }
            return true;
        });

        const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

        if (subtopicData.importFile !== '' && subtopicData.importFile.length !== 0) {
            if (!isQuestionDataNotEmpty) {
                return false;
            }
        }
        return subtopicDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            const newErrors = {};

            // Validate each field in subtopicData
            for (const [key, value] of Object.entries(subtopicData)) {
                if (key !== 'instituteCompetitiveTopicMasterId' && key !== 'instituteCompetitiveSubTopicMasterId') {
                    if (typeof value === 'string' && value.trim() === '') {
                        newErrors[key] = 'This field is required.';
                    } else {
                        newErrors[key] = ''; // Clear error if field is valid
                    }
                }
            }

            const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

            if (subtopicData.importFile !== '' && subtopicData.importFile.length !== 0) {
                if (!isQuestionDataNotEmpty) {
                    newErrors['questionData'] = 'At least one question is required.';
                } else {
                    newErrors['questionData'] = ''; // Clear error if questionData is valid
                }
            }

            setError(newErrors); // Update error state with newErrors
        }
    }, [subtopicData])

    const callQuestionBankSaveApi = (apiUrl, modifiedSubtopicData) => {
        return authorizedAxiosInstitute && authorizedAxiosInstitute.post(apiUrl, modifiedSubtopicData)
            .then(response => {
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        instituteCompetitiveLessonMasterId: '',
                        instituteCompetitiveTopicMasterId: '',
                        instituteCompetitiveSubTopicMasterId: '',
                        competitiveSubTopicName: '',
                        importFile: '',
                        questionData: []
                    }
                })
                inputFile.current.value = '';
                setQuestionList([]);
                setErrorQuestions({});
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            });
    }

    const addTopic = () => {
        if (!validateForm()) {
            handleFormErrors();
            return;
        }

        setLoading(true);
        const modifiedSubtopicData = { ...subtopicData };
        const fileExtension = subtopicData.importFile.split('.').pop().toLowerCase();
        delete modifiedSubtopicData.importFile;

        const questionIds = validateQuestionData(subtopicData.questionData, false);
        if (questionIds.errorCount > 0) {
            handleQuestionErrors(questionIds.errorquestionIds);
            setLoading(false);
            return;
        }

        const apiUrl = fileExtension === "docx"
            ? '/import-competitive-question-bank-docx'
            : '/import-competitive-question-bank-xlsx';

        callQuestionBankSaveApi(apiUrl, modifiedSubtopicData)
            .finally(() => {
                setLoading(false); // End loading
            });
    };

    const handleFormErrors = () => {
        const newErrors = {};

        for (const [key, value] of Object.entries(subtopicData)) {
            if (key !== 'instituteCompetitiveTopicMasterId' && key !== 'instituteCompetitiveSubTopicMasterId') {
                newErrors[key] = typeof value === 'string' && value.trim() === '' ? 'This field is required.' : '';
            }
        }

        if (subtopicData.importFile !== '' && subtopicData.questionData.length === 0) {
            newErrors['questionData'] = 'At least one question is required.';
        } else {
            newErrors['questionData'] = '';
        }

        setError(newErrors);
    };

    const handleQuestionErrors = (errorQuestionIds) => {
        const matchedQuestionIndices = errorQuestionIds
            .map(id => {
                const index = questionList.findIndex(question => question.no === id);
                return index !== -1 ? (index + 1).toString() : null;
            })
            .filter(index => index !== null)
            .join(', ');

        const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

        Swal.fire({ text: message });
    };

    const reset = () => {
        setSubtopicData(initialFormState);
        questionList([]);
        setErrorQuestions({});
        setModalImageSrc('');
        setSubtopicList([])
        setEditId('')
        inputpdf.value = ''
    }

    const deleteSubtopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            const apiUrl = `/delete-competitive-sub-topic?id=${id}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.delete(apiUrl)
                .then(response => {
                    setSubtopicList((prevSubtopicList) => [...prevSubtopicList].filter((subtopic) => subtopic.id !== id))
                    // openSuccessSnackbar(response.data.message);
                    Swal.fire(
                        { text: response.data.message }
                    );
                    console.log('Data:', response.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                });
        }
    }

    const updateSubtopic = () => {
        const apiUrl = `/edit-competitive-sub-topic?id=${editId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.put(apiUrl, subtopicData)
            .then(response => {
                setEditId(null);
                // setSubtopicData(initialFormState);
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        competitiveSubTopicName: ''
                    }
                })

                // openSuccessSnackbar(response.data.message);
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            });
    }

    useEffect(() => {
        if (showPdfLink !== null) {
            if (showPdfLink.indexOf('[') >= 0) {
                setShowPdfLikDateType("array")
                setJasonParse(JSON.parse(showPdfLink))
            } else {
                setShowPdfLikDateType("string")
                setText(showPdfLink)
            }
        } else {
            setShowPdfLikDateType("string")
            setText(showPdfLink)
        }
    }, [showPdfLink])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Upload</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i> Competitive Exam Upload</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam  Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveExamNameMasterId' onChange={handleSyllabusChange} value={subtopicData.instituteCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam  Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveExamNameMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveExamBookMasterId' onChange={handleBookChanges} value={subtopicData.instituteCompetitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                console.log("handle book change : ", syllabus)
                                                                return <option value={syllabus?.id}>{syllabus?.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveExamBookMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveExamBookMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChanges} value={subtopicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                console.log("syllabus", syllabus);
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveLessonMasterId' onChange={handleLessonChange} value={subtopicData.instituteCompetitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveLessonMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveLessonMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveTopicMasterId' onChange={handleTopicChange} value={subtopicData.instituteCompetitiveTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.competitiveTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveTopicMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveTopicMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveSubTopicMasterId' onChange={handleInputChange} value={subtopicData.instituteCompetitiveSubTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subtopicListName?.map((subtopic) => {
                                                                return <option value={subtopic.id}>{subtopic.competitiveSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveTopicMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveTopicMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Competitive Question Bank :<span style={{ color: "red" }}>only xlsx & docx file supported</span></label>
                                                    <input required type="file" className="form-control" name="importFile" onChange={handleUploadLogo} ref={inputFile} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>&nbsp;
                                                    <a download href='https://api.examninja.co.in/files/SampleDoc.docx'>Sample docx file</a>
                                                    {error.importFile && <p style={{ color: 'red' }}>{error.importFile}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        }                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={reset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSubtopic} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                >

                                                    <div className="book book-modal">
                                                        <div className='table-header-like'>  {selectedGrade} - {selectedDivision}</div>
                                                        <div style={{ overflowY: "scroll", }} className='page' >
                                                            <div>
                                                                {
                                                                    showPdfLinkdataType == "array" ?
                                                                        // console.log(jsonPars)
                                                                        <table class="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                                    <th scope="col">Name </th>
                                                                                    <th scope="col">Purpose </th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    jsonPars.map((lesson, index) => {
                                                                                        return (
                                                                                            <tr>
                                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                                <td>{lesson.record[2]}</td>
                                                                                                <td>{lesson.purpose}</td>
                                                                                            </tr>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                        :
                                                                        <div className='no-error-class'>{text ? text : "No error found"}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>

                                                {visibleSolution && <SolutionModal visibleSolution={visibleSolution} setVisibleSolution={setVisibleSolution} modalData={modalData} />}

                                                {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}

                                                {/* {questionList.length === 0 && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Uploaded Files </th>
                                                                        <th scope="col">Total Question Count</th>
                                                                        <th scope="col">Imported Question Count</th>
                                                                        <th scope="col">Exam</th>
                                                                        <th scope="col">Book</th>
                                                                        <th scope="col">Subject</th>
                                                                        <th scope="col">Lesson</th>
                                                                        <th scope="col">Topic</th>
                                                                        <th scope="col">Sub Topic</th>
                                                                        <th scope="col">Note</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        subtopicList?.length > 0 ?
                                                                            subtopicList.map((lesson) => {
                                                                                return (
                                                                                    <tr className={lesson.importStatus == "IMPORTED" ? 'greenTable' : lesson.importStatus == "FAILED" ? "redTable" : lesson.importStatus == "NOT STARTED" ? "yellowTable" : "yellowTable"}>
                                                                                        <td>{getFileName(lesson?.localFilePath)}<a href={lesson.localFilePath} download style={{ textDecoration: "none" }}><i class="fa-solid fa-download"></i></a></td>
                                                                                        <td>{lesson.importedQuestionCount}</td>
                                                                                        <td>{lesson.importedQuestionCount}</td>
                                                                                        <td>{lesson?.instituteCompetitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{lesson?.instituteCompetitiveExamBookMasterDetails?.bookName}</td>
                                                                                        <td>{lesson?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{lesson?.instituteCompetitiveLessonMasterDetails?.competitiveLessonName}</td>
                                                                                        <td>{lesson?.instituteCompetitiveTopicMasterDetails?.competitiveTopicName}</td>
                                                                                        <td>{lesson?.instituteCompetitiveSubTopicMasterDetails?.competitiveSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {

                                                                                                setShowPdfLink(lesson.note)
                                                                                                setVisible(true)
                                                                                                setSelectedGrade(lesson?.instituteCompetitiveExamNameMasterDetails?.examName)
                                                                                                setSelectedDivision(lesson?.instituteCompetitiveExamBookMasterDetails?.bookName)
                                                                                            }}><i class="fa fa-eye" ></i> Error</button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>} */}

                                                {questionList.length !== 0 && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                        <div>
                                                            {errorQuestions.errorCount > 0 && (
                                                                <div className="alert alert-danger" role="alert">
                                                                    {errorQuestions.errorCount === 1 ?
                                                                        `There is ${errorQuestions.errorCount} invalid or empty question` :
                                                                        `There are ${errorQuestions.errorCount} invalid or empty questions`
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                        {error.questionData && <p style={{ color: 'red' }}>{error.questionData}</p>}
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    {questionList?.length > 0 && <th>
                                                                        <input
                                                                            type='checkbox'
                                                                            checked={subtopicData.questionData.length === questionList.length}
                                                                            onClick={() => handleSelectAll(questionList, subtopicData, setSubtopicData)}
                                                                        /> All
                                                                    </th>}
                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                    <th scope='col'>Q_Level</th>
                                                                    <th scope='col'>Q_Type</th>
                                                                    <th scope='col'>Question</th>
                                                                    <th scope="col">Option_a</th>
                                                                    <th scope="col">Option_b </th>
                                                                    <th scope="col">Option_c</th>
                                                                    <th scope="col">Option_d</th>
                                                                    <th scope='col'>Answer</th>
                                                                    <th scope='col'>Solution</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    questionList?.length > 0 ?
                                                                        questionList?.map((question, index) => {
                                                                            const rowClass = isErrorQuestion(errorQuestions, question) ? 'error-row' : '';

                                                                            return (
                                                                                <tr key={index} className={rowClass}>
                                                                                    <td><input type='checkbox' checked={subtopicData.questionData.some(q => q.no === question.no)} onChange={() => handleQuestionUpdate(question, subtopicData, setSubtopicData)} /></td>
                                                                                    <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                    <td>E</td>
                                                                                    <td>S</td>
                                                                                    {/* <td><ViewImageAndText inputString={question.question} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['a)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['b)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['c)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['d)']} onViewImage={onViewImage} /></td> */}
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['a)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['b)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['c)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['d)'] }} /></td>
                                                                                    <td>{question.answer}</td>
                                                                                    <td>
                                                                                        <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                            setVisibleSolution(!visibleSolution)
                                                                                            setModalData(question.solution)
                                                                                        }}><i class="fa fa-eye" ></i></button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteUploadCompetitiveExam;